import clearRegion from './clear-region';
import cookies from './cookies';
import recontext from './recontext';

export const userContext = {
  clearRegion,
  cookies,
  recontext,
};
